import React from "react";
import { MediaPlacement, StyleOptions } from ".";
import {
  Image,
  Vector,
  KontentRichText,
  ComponentProps,
  ComponentWidth,
  Video,
} from "../../../types";
import { SectionWrapper } from "../../containers/SectionWrapper";
import { CustomRichTextElement } from "../../elements/CustomRichTextElement/CustomRichTextElement";
import * as styles from "./HighlightedSection.module.css";
import { ArtDirectedImageElement } from "../../elements/KontentImageElement/ArtDirectedImageElement";
import VideoPlayer from "../../elements/VideoPlayer/VideoPlayer";

interface Props extends ComponentProps, ComponentWidth {
  media:
    | {
        largeImage: Image;
        smallImage: Image;
      }
    | Video;
  vector: Vector;
  heading?: string;
  text: KontentRichText;
  mediaPlacement: MediaPlacement;
  style?: StyleOptions;
}

export const HighlightedSection: React.FC<Props> = ({
  media,
  vector,
  heading,
  text,
  mediaPlacement,
  width,
  style,
  ...props
}) => {
  const wrapperClassName = [styles.highlightedsection];
  width === "contained" && wrapperClassName.push(styles.contained);
  style === "transparent" && wrapperClassName.push(styles.transparent);
  style === "light" && wrapperClassName.push(styles.light);

  const contentClassName = [styles.content];
  mediaPlacement === "right" && contentClassName.push(styles.reverse);

  const renderMedia = (media: any) => {
    if (media?.videoUrl) {
      return (
        <VideoPlayer
          src={media?.videoUrl}
          thumbnail={media?.thumbnail?.item?.url}
          display="inline"
          arrowSize="88px"
        />
      );
    }

    return (
      <ArtDirectedImageElement
        desktopImage={{
          image: media.largeImage.item,
          layout: "fullWidth",
          backgroundColor: "#bbbbbb",
        }}
        mobileImage={{
          image: media.smallImage?.item,
          layout: "fullWidth",
          backgroundColor: "#bbbbbb",
        }}
        className={styles.artDirected}
        focalPoint={media.largeImage.focalPoint}
        animation={"fadeInUp"}
      />
    );
  };

  return (
    <SectionWrapper {...props}>
      <div className={wrapperClassName.join(" ")}>
        {vector?.item?.url && (
          <div className={styles.vector + " hide-mobile"}>
            <img src={vector.item.url} alt={vector.alt} />
          </div>
        )}
        {heading && (
          <div className={styles.heading}>
            <h2>{heading}</h2>
          </div>
        )}
        <div className={contentClassName.join(" ")}>
          <div className={styles.image}>{renderMedia(media)}</div>
          <div className={styles.text}>
            <CustomRichTextElement content={text} />
          </div>
        </div>
      </div>
    </SectionWrapper>
  );
};
